var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"event-documents"},[_c('content-header',{attrs:{"path":"Documentos"}}),_vm._v(" "),_c('section',{staticClass:"row documentcontent"},[_c('section',{staticClass:"col-8"},[_c('item-documents')],1),_vm._v(" "),_c('section',{staticClass:"col-4"},[_c('document-upload')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df2a31d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/event-documents/EventDocuments.vue
// module id = null
// module chunks = 